module.exports = __webpack_public_path__ + "static/media/Icon-oil.24f138c5.svg";